import React, { memo } from 'react'

import { SectionItem } from '../sectionItem'
import styles from './myExperience.module.scss'

function MyExperience() {
  const experienceList = [
    {
      position: 'Full Stack Developer',
      company: 'AVALANT CO.,LTD.',
      duration: 'Mar 2017 - Sep 2017',
      job: 'Develop websites by using Angular2 and Java',
    },
    {
      position: 'Front - end Developer',
      company: 'LQID360 CO.,LTD.',
      duration: 'Oct 2017 - PRESENT',
      job: 'Develop mobile application by using React Native and website by using React.',
    },
  ]

  return (
    <SectionItem topic="experiences">
      <ul className={styles.exp__list}>
        {experienceList.map(exp => (
          <li key={exp.company} className={styles.exp__list_item}>
            <div className={styles.exp__position}>{exp.position}</div>
            <div className={styles.exp__company}>
              {`${exp.company} ----- ${exp.duration}`}
            </div>
            <div className={styles.exp__job}>{exp.job}</div>
          </li>
        ))}
      </ul>
    </SectionItem>
  )
}

export default memo(MyExperience)
